import {useSearchParams} from "react-router-dom";
import useRootHook from "../hooks/useRoot";
import {useEffect, useState} from "react";
import payment from '../models/payment'
import {Container, Typography} from "@mui/material";
import SectionCard from "./layout/SectionCard";

export default function Payment () {
    const [searchParams] = useSearchParams()
    const {setShowLoader} = useRootHook()
    const [text, setText] = useState('Please wait...')

    useEffect(() => {
        setShowLoader(true)
        payment.getLink({
            customer: searchParams.get('c'),
            currency: searchParams.get('cr'),
            amount: searchParams.get('a'),
        }).then((urlData) => {
            setShowLoader(false)
            // On success we get { url }; on any error we get no url — always show generic message
            if (urlData?.url) {
                window.location.href = urlData.url
            } else {
                setText('Error occurred')
            }
        }).catch(() => {
            setShowLoader(false)
            setText('Error occurred')
        })
    }, [])

    return (
        <Container maxWidth="sm" sx={{ py: 6 }}>
            <SectionCard sx={{ textAlign: 'center', py: 6 }}>
                <Typography variant="h5" gutterBottom>
                    {text}
                </Typography>
            </SectionCard>
        </Container>
    )
}